export function exit(state, object, patch, opts) {
    opts.error = patch;
    return opts.partial && state.root ? state.root[''] : object;
}
